import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import {Card,CardContent,Box} from "@material-ui/core";
import NumberFormat from 'react-number-format';
const useStyles = makeStyles((theme) => ({
    card:{
      height:3.5+'rem',
      width:120,     
      color:'white',
      marginRight:'.5em',
    },
    titulo:{        
        textAlign:'center',
        marginTop:'-.4rem',
        fontSize:'1.1rem',
        fontWeight:600
    },
    tituloColor:{
        textAlign:'center',
        marginTop:'-.6rem',
        fontSize:'1.1rem',
        fontWeight:600
    },
    subtitulo:{        
        textAlign:'center',
        marginTop:'-1.4rem',
        fontSize:'.9rem',
    },
    subtituloCard:{       
        textAlign:'center',
        marginTop:'.1rem',
        fontSize:'.9rem',
    },
}));


export default function CardPerfil({valor}){
    const classes = useStyles();
    
    function generarCards(mensaje,datos, ){
        return( 
        <CardContent>
            <div className={classes.tituloColor} 
                style={{color:'white'}} 
            >                
                <NumberFormat value={datos} displayType={'text'}  thousandSeparator={true}/>
            </div>
            <p className={classes.subtituloCard} >
                {mensaje}
            </p>
        </CardContent>
        )
    }

    function generarCards2(mensaje,datos,auxColor){
        return( 
        <CardContent>
            <Card className={classes.tituloColor} 
                style={{color:'white'}} 
            >                
                <NumberFormat value={datos} displayType={'text'}  thousandSeparator={true}/>
            </Card>
            <p className={classes.subtituloCard} >
                {mensaje}
            </p>
        </CardContent>
        )
    }
  
  
    return (         
    <Box display="flex" flexDirection="row" mb={1}  >   
        <Box display="flex" flexDirection="row">                                    
            <Card className={classes.card} style={{backgroundColor:'#19A11E'}}>
                {generarCards('Valido',valor.Valido)}
            </Card>
            <Card className={classes.card} style={{backgroundColor:'#FBBE06'}} >
                {generarCards('Pendiente',valor.Pendiente )}
            </Card>
            <Card className={classes.card} style={{backgroundColor:'#E91E63'}} >
                {generarCards('Rechazado', valor.Rechazado,)}
            </Card>            
        </Box>   
    </Box>
    );
}
 